import { render, staticRenderFns } from "./EtapaModal.vue?vue&type=template&id=b4a3a472&scoped=true"
import script from "./EtapaModal.vue?vue&type=script&lang=js"
export * from "./EtapaModal.vue?vue&type=script&lang=js"
import style0 from "./EtapaModal.vue?vue&type=style&index=0&id=b4a3a472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a3a472",
  null
  
)

export default component.exports